function MasterIcon(props) {
  const { isActive } = props
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 12V0H12V12H0ZM1.33333 3.55H10.6667V1.33333H1.33333V3.55ZM1.33333 7.11667H10.6667V4.88333H1.33333V7.11667ZM1.33333 10.6667H10.6667V8.45H1.33333V10.6667ZM2 3.1V1.76667H3.33333V3.1H2ZM2 6.66667V5.33333H3.33333V6.66667H2ZM2 10.2333V8.9H3.33333V10.2333H2Z"
        fill={!isActive ? '#828282' : '#FFFFFF'}
      />
    </svg>
  )
}

export default MasterIcon
